import { useState } from 'react';

export const useContactForm = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    companyEmail: '',
    phoneNumber: '',
    companySize: '',
    country: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    // Here you would normally send data to an API
    
    // Reset form
    setFormData({
      firstName: '',
      lastName: '',
      companyEmail: '',
      phoneNumber: '',
      companySize: '',
      country: '',
      message: ''
    });
  };

  const companySizes = [
    'Less than 10 employees',
    '11-50 employees',
    '51-200 employees',
    '201-500 employees',
    '501-1000 employees',
    'More than 1000 employees'
  ];

  const countries = [
    'United States',
    'Canada',
    'United Kingdom',
    'Germany',
    'France',
    'Australia',
    'Other'
  ];

  return {
    formData,
    handleChange,
    handleSubmit,
    companySizes,
    countries
  };
}; 